module.exports = __webpack_public_path__ + "static/media/img_fundo_one7_mais_credito.9a80b9fe.png";